package com.ives.modules.vrc;

import js.Browser;
import js.html.OptionElement;

import com.ives.modules.mip.RayCastingClient;
import com.ives.utils.Remoting;
import com.ives.modules.adjustments.Adjustments;
import com.ives.modules.vrc.ReconstructionSettings;
import com.ives.components.viewer.DicomViewer;
import com.ives.components.workspace.DicomWorkspace;
import com.ives.modules.ModuleEvent;
import com.ives.utils.Config;

// https://en.wikipedia.org/wiki/Volume_ray_casting
class VRC extends RayCastingClient{
	static private inline var VRC_MODULE:String = "VRC_MODULE";
	static private inline var VRC_WORKSPACE:String = "VRC_WORKSPACE";
	static private inline var VRC_EVENT:String = "VRC_EVENT";

	static private inline var STANDARD_LUT:String = "standard";

	private var luts:Array<ColorLUT>;
	private var currentLutName:String = STANDARD_LUT;

	public function new(){
		settingSteps = [
			new ReconstructionSettings(256, 256, true, 10, 500),
			new ReconstructionSettings(256, 256, true, 5, 3000),
			new ReconstructionSettings(512, 512, true, 1, 500)
		];
	}

	override public function init(dicomViewer:DicomViewer, ?dicomWorkspace:DicomWorkspace){
		superInit(dicomViewer, dicomWorkspace);

		if(getWorkspaceMode() != VRC_WORKSPACE)
			return;

		Remoting.colorLUTs(onColorLuts);

		lutSelect.style.display = "block";
		lutSelect.addEventListener("change", onSelectChange);
	}

	private function onSelectChange(){
		for(lut in luts)
			if(lutSelect.value == lut.name){
				onLutChange(lut);

				break;
			}
	}

	private function onColorLuts(luts:Array<ColorLUT>){
		this.luts = luts;

		var index:Int = 0;

		for(n in 0...luts.length){
			var lut:ColorLUT = luts[n];

			var option:OptionElement = Browser.document.createOptionElement();

			option.innerHTML = lut.name;
			option.value = lut.name;

			lutSelect.appendChild(option);

			if(lut.name == STANDARD_LUT)
				index = n;
		}

		lutSelect.selectedIndex = index;

		onLutChange(luts[index]);
	}

	private function onLutChange(lut:ColorLUT){
		currentLutName = lut.name;

		dispatchEvent(new ModuleEvent(Adjustments.ADJUSTMENTS_WINDOW, [lut.center, lut.width], workspaceIdForEvent(), false, true));
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == VRC_MODULE && getWorkspaceMode() != VRC_WORKSPACE)
			dispatchEvent(new ModuleEvent(DicomViewer.LAYOUT_CHANGE, [1, 1], [VRC_WORKSPACE]));

		if(event.type == VRC_EVENT && getWorkspaceMode() == VRC_WORKSPACE)
			handleEvent(event);

		if(event.type == Adjustments.ADJUSTMENTS_WINDOW && getWorkspaceMode() == VRC_WORKSPACE)
			start();

		if(event.type == DicomWorkspace.WORKSPACE_READY && getWorkspaceMode() == VRC_WORKSPACE)
			super.init(dicomViewer, dicomWorkspace);
	}

	override private function setUrl(settings:ReconstructionSettings){
		dicomWorkspace.dicomImage.setBaseUrl('${Config.SERVER_URL}/dicom/${dicomViewer.originalDicomImageData.sourceName}/context/${dicomViewer.originalDicomImageData.id}/vrc?rotation=${rotation}&screen=${screen}&distance=${cameraDistance}&fov=${fov}&spacing=${pixelSpacing}&step=${settings.step}&lut=${currentLutName}&shading=${settings.shading}');
	}

	override private function updateCamera(data:Array<Float>){
		dispatchEvent(new ModuleEvent(VRC_EVENT, data, false, true));
	}
}
